import {getFileIconClsByURL} from "../../../../Components/APIForm/Fields/FileWidget";

const MessageFile = ({message}) => {
    return message.file_url && <div className="message-file-type">
        <a href={message.file_url} target='_blank' rel="noopener noreferrer" className='message-file layout-align-start-center layout-row'>
            <div className={`${getFileIconClsByURL(message.file_url)} bg-size-cover bg-center m-1 mr-2`} style={{height: 30, width: 40}}></div>
            <div className='file-url'>{message.text ? message.text : message.file_url}</div>
        </a>
    </div>
}

export default MessageFile;